// extracted by mini-css-extract-plugin
export var closeButton = "_a-0";